import $ from "jquery";
import Formatter from "@rmlibrary/formatting";

const formatter = new Formatter();
const language = getLanguage();
const storageKeyPrefix = "ca.dynamic.calculators.";

function getDateRangeFromDate(date, range) {
    let [month, year] = date.split("/");
    year = Number(year);
    let endDate = new Date(`${month}/01/${year}`);
    const startDateMonth = month - 1 < 1 ? 12 : month - 1;
    let startDate = new Date(`${startDateMonth}/01/${year - range}`);
    endDate = formatter
        .formatDate(endDate, "mmm yyyy")
        .replace(/June/g, "Jun")
        .replace(/July/g, "Jul")
        .replace(/1éc/g, "déc");
    startDate = formatter
        .formatDate(startDate, "mmm yyyy")
        .replace(/June/g, "Jun")
        .replace(/July/g, "Jul")
        .replace(/1éc/g, "déc");

    return `${startDate} - ${endDate}`;
}

function getNoDayDateFromDate(date) {
    let [month, year] = date.split("/");
    year = Number(year);
    let formattedDate = new Date(`${month}/01/${year}`);
    formattedDate = formatter.formatDate(formattedDate, "mmm yyyy").replace(/June/g, "Jun").replace(/July/g, "Jul");

    return formattedDate;
}

function outputAttribute(name, inputs, callback) {
    $(".print-page-wrapper, rm-html-pdf")
        .find(`[${name}]`)
        .each((i, element) => {
            const path = $(element).attr(name);
            const value = getValue(inputs, path);
            callback(element, value);
        });
}

function debounce(fn, t, immediate) {
    var timer;
    return function () {
        var thisArg = this,
            args = arguments;
        var noTimer = !timer;

        clearTimeout(timer);
        timer = setTimeout(function () {
            timer = null;
            if (!immediate && typeof fn === "function") fn.apply(thisArg, args);
        }, t);

        if (immediate && noTimer && typeof fn === "function") fn.apply(thisArg, args);
    };
}

function filterObjectByKeys(object, keys, blacklisted = true) {
    return Object.keys(object).reduce((accumulator, k) => {
        let returnValue = accumulator;

        if ((blacklisted && !keys.includes(k)) || (!blacklisted && keys.includes(k))) {
            returnValue = {
                ...accumulator,
                [k]: object[k]
            };
        }

        return returnValue;
    }, {});
}

function formatLargeCurrency(amount) {
    let formattedAmount = null;

    if (amount >= 1000000000) {
        const normalizedAmount = amount / 1000000000;
        const decimals = normalizedAmount % 1 !== 0 ? 1 : 0;
        const dollarPrefix = language === "en" ? "$" : "";
        formattedAmount = formatter.formatNumber(normalizedAmount, decimals);
        const abbreviation = language === "en" ? "b" : " G";
        const dollarSuffix = language === "fr" ? "$" : "";
        formattedAmount = `${dollarPrefix}${formattedAmount}${abbreviation}${dollarSuffix}`;
    } else if (amount >= 1000000) {
        const normalizedAmount = amount / 1000000;
        const decimals = normalizedAmount % 1 !== 0 ? 1 : 0;
        const dollarPrefix = language === "en" ? "$" : "";
        formattedAmount = formatter.formatNumber(normalizedAmount, decimals);
        const abbreviation = language === "en" ? "m" : " M";
        const dollarSuffix = language === "fr" ? "$" : "";
        formattedAmount = `${dollarPrefix}${formattedAmount}${abbreviation}${dollarSuffix}`;
    } else if (amount >= 10000) {
        const normalizedAmount = amount / 1000;
        const dollarPrefix = language === "en" ? "$" : "";
        formattedAmount = formatter.formatNumber(normalizedAmount, 0);
        const abbreviation = language === "en" ? "k" : " k";
        const dollarSuffix = language === "fr" ? "$" : "";
        formattedAmount = `${dollarPrefix}${formattedAmount}${abbreviation}${dollarSuffix}`;
    } else if (amount >= 1000) {
        const normalizedAmount = amount / 1000;
        const decimals = normalizedAmount % 1 !== 0 ? 1 : 0;
        const dollarPrefix = language === "en" ? "$" : "";
        formattedAmount = formatter.formatNumber(normalizedAmount, decimals);
        const abbreviation = language === "en" ? "k" : " k";
        const dollarSuffix = language === "fr" ? "$" : "";
        formattedAmount = `${dollarPrefix}${formattedAmount}${abbreviation}${dollarSuffix}`;
    } else {
        formattedAmount = formatter.formatCurrency(amount, 0);
    }

    return formattedAmount;
}

function getValue(object, path) {
    function getResult(separator) {
        return path
            .split(separator)
            .filter((part) => part)
            .reduce((result, part) => (result !== null && result !== undefined ? result[part] : result), object);
    }

    if (!path) {
        return null;
    }

    const result = getResult(/[,[\]]+?/) || getResult(/[,[\].]+?/);
    return result === undefined || result === object ? null : result;
}

function generatePDF(inputs) {
    const currentDate = new Date();

    inputs = {
        ...inputs,
        currentDate
    };

    outputAttribute("data-alt", inputs, (element, value) => $(element).attr("alt", value));

    outputAttribute("data-colour", inputs, (element, value) => {
        if (value.indexOf("#") > -1) {
            value = getRGBFromHex(value, true);
        }

        $(element).css("background-color", value);
    });

    outputAttribute("data-if", inputs, (element, value) => {
        if (!value) {
            $(element).hide();
        }
    });

    outputAttribute("data-src", inputs, (element, value) => {
        if (value) {
            const base = $(element).attr("data-src-base") || "";
            if ($(element).css("visibility") === "hidden") {
                $(element).one("load", () => $(element).css("visibility", "visible"));
            }
            $(element).attr("src", `${base}${value}`);
        }
    });

    outputAttribute("data-output-currency", inputs, (element, value) => {
        try {
            let decimals = $(element).attr("data-output-decimals");
            if (decimals === "auto") {
                decimals = value % 1 !== 0 ? 2 : 0;
            } else {
                decimals = Number($(element).attr("data-output-decimals")) || 0;
            }

            $(element).text(formatter.formatCurrency(value, decimals));
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-date", inputs, (element, value) => {
        try {
            const type = $(element).attr("data-output-type");

            if (type === "noDay") {
                $(element).text(getNoDayDateFromDate(value));
            } else if (type === "range") {
                let range = $(element).attr("data-output-range");
                range = getValue(inputs, range) || 1;

                $(element).text(getDateRangeFromDate(value, range));
            } else {
                const format = getLanguage() === "en" ? "mmmm ddd, yyyy" : "ddd mmmm yyyy";

                $(element).text(formatter.formatDate(value, format));
            }
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-number", inputs, (element, value) => {
        try {
            const decimals = Number($(element).attr("data-output-decimals")) || 0;

            $(element).text(formatter.formatNumber(value, decimals));
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-percentage", inputs, (element, value) => {
        try {
            const decimals = Number($(element).attr("data-output-decimals")) || 0;
            const inputType = $(element).attr("data-input-type") || "percent";

            if (inputType === "decimal") {
                value *= 100;
            }

            $(element).text(formatter.formatPercentage(value, decimals));
        } catch (error) {
            $(element).text("");
        }

        $(element).css("visibility", "visible");
    });

    outputAttribute("data-output-text", inputs, (element, value) => {
        let textValue = value ? value.toString() : "";
        const lineBreakCharacter = $(element).attr("data-output-line-break-character") || "";
        if (textValue && lineBreakCharacter) {
            const characterIndex = textValue.indexOf(lineBreakCharacter);
            if (characterIndex > -1) {
                textValue = `${textValue.slice(0, characterIndex)}<br />${textValue.slice(characterIndex)}`;
            }
        }

        $(element).html(textValue);
        $(element).css("visibility", "visible");
    });
}

function getLanguage() {
    return document.documentElement.lang.toLowerCase().indexOf("en") > -1 ? "en" : "fr";
}

function getMonthAndYearFromTimestamp(timestamp) {
    const date = new Date(timestamp * 1000);
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();

    return `${month / 10 < 1 ? "0" + month : month}/${year}`;
}

function getRGBFromHex(hex, toString = false) {
    const rgb = hex
        .replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i, (m, r, g, b) => "#" + r + r + g + g + b + b)
        .substring(1)
        .match(/.{2}/g)
        .map((x) => parseInt(x, 16));

    return toString ? `rgb(${rgb})` : rgb;
}

function getTextWidth(text, font) {
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = font;
    const textMetrics = context.measureText(text);

    return textMetrics.width;
}

function getTimestampFromDate(date) {
    let [month, year] = date.split("/");
    month = Number(month) - 1;
    year = Number(year);

    return Date.UTC(year, month) / 1000;
}

function getValueFromInput(selector) {
    const { checked, type, value } = document.querySelector(selector);

    if (type === "checkbox" || type === "radio") {
        return checked;
    }

    return value;
}

function getYearFromTimestamp(timestamp) {
    return new Date(timestamp * 1000).getUTCFullYear();
}

function hideError(id) {
    const errorElement = document.getElementById(id);

    errorElement.setAttribute("aria-hidden", "true");
    errorElement.removeAttribute("role");
    errorElement.style.display = "none";
}

function interpolateValue({ x1, y1, x2, y2, x }) {
    return y1 + (x - x1) * ((y2 - y1) / (x2 - x1));
}

function isIE() {
    return /Trident\/7\./.test(navigator.userAgent) || navigator.userAgent.indexOf("MSIE ") >= 0;
}

function pluralizeText(word, count, inclusive = true) {
    return `${inclusive ? count : ""} ${word}${count !== 1 ? "s" : ""}`;
}

function retrieveFromStorage(page) {
    const storageKey = `${storageKeyPrefix}${page}`;

    return JSON.parse(sessionStorage.getItem(storageKey));
}

function roundToNiceNumber(number, factor = 1, mode = "ceiling") {
    const { length } = Math.round(number).toString();
    const multiplier = 10 ** (length - 2) * factor;

    let result = Math.ceil(number / multiplier);
    if (mode === "floor") {
        result = Math.floor(number / multiplier);
    }

    return result * multiplier;
}

function saveToStorage(page, value) {
    const storageKey = `${storageKeyPrefix}${page}`;

    sessionStorage.setItem(storageKey, JSON.stringify(value));
}

function showError(id, eventType) {
    if (eventType !== "keyup") {
        const errorElement = document.getElementById(id);

        errorElement.setAttribute("aria-hidden", "false");
        errorElement.setAttribute("role", "alert");
        errorElement.style.display = "block";
        errorElement.focus();
    }
}

function showPopup(popup, updateContent, isBar, points) {
    return (dataName, x, y, xPos, yPos, xValOnGraph, yValOnGraph, isLine) => {
        if (!isLine) {
            if (updateContent) {
                updateContent({ dataName, popup, x, y });
            }

            let barWidthOffset = 0;
            let barTopOffset = 0;
            const xOffset = $(popup).outerWidth() / 2;
            const yOffset = $(popup).outerHeight() + 20;

            if (isBar) {
                const point = points.filter((point) => point.x === x && point.y === y)[0];

                barWidthOffset = Math.abs(point.coords.x2 - point.coords.x1) / 2;
                if (y < 0) {
                    barTopOffset = Math.abs(point.coords.y2 - point.coords.y1);
                } else {
                    barTopOffset = 15;
                }
            }

            $(popup).css({
                left: `${xValOnGraph - xOffset + barWidthOffset}px`,
                top: `${yValOnGraph - yOffset - barTopOffset}px`,
                visibility: "visible"
            });
        }
    };
}

function throttle(fn, t, immediate) {
    var lastArgs, timer;

    return function () {
        var thisArg = this,
            args = Array.prototype.slice.call(arguments, 0),
            noTimer = !timer;

        function timeoutFn() {
            if (lastArgs) {
                if (typeof fn === "function") fn.apply(thisArg, lastArgs);
                lastArgs = null;
                timer = setTimeout(timeoutFn, t);
            } else {
                timer = null;
            }
        }

        if (!noTimer || !immediate) {
            lastArgs = args;
        }
        if (!timer) timer = setTimeout(timeoutFn, t);
        if (immediate && noTimer && typeof fn === "function") fn.apply(thisArg, args);
    };
}

export {
    debounce,
    filterObjectByKeys,
    formatLargeCurrency,
    generatePDF,
    getLanguage,
    getMonthAndYearFromTimestamp,
    getRGBFromHex,
    getTextWidth,
    getTimestampFromDate,
    getValueFromInput,
    getYearFromTimestamp,
    hideError,
    interpolateValue,
    isIE,
    pluralizeText,
    retrieveFromStorage,
    roundToNiceNumber,
    saveToStorage,
    showError,
    showPopup,
    throttle
};
